import React from 'react';
import Sidebar from '../Sidebar';
import Dashboard from '../Dashboard';
import FaqMain from './FaqMain'

export default function Faq() {
    return (
        <div>
            <Dashboard cmp={<FaqMain />} />
        </div>
    )
}
